import { get } from "../../../logics/src/utils/helpers";

function cleanAddress(formattedAddress: string) {
    try {
        // Check if the input is an empty string or contains only whitespace
        if (!formattedAddress || formattedAddress.trim() === "") {
            return ""; // Return an empty string if the input is empty or just whitespace
        }
    
        // Split the address into an array using commas as the separator
        let addressParts = formattedAddress.split(',').map(part => part.trim());
    
        // Regex to check if a string contains any numeric characters
        const containsNumericRegex = /\d/;
    
        // 1. Remove the first element if it contains any numeric or alphanumeric characters
        if (addressParts.length > 0 && containsNumericRegex.test(addressParts[0])) {
            addressParts.shift(); // Remove the first element
        }
    
        // 2. Remove the last element if it is "India"
        if (addressParts.length > 0 && addressParts[addressParts.length - 1].toLowerCase() === 'india') {
            addressParts.pop(); // Remove the last element
        }
    
        // 3. Remove the second last element if it contains any numeric characters
        if (addressParts.length > 1 && containsNumericRegex.test(addressParts[addressParts.length - 1])) {
            addressParts.splice(addressParts.length - 1, 1); // Remove the second last element
        }
    
        // Return empty string if only numeric parts are left
        if (addressParts.length === 0 || addressParts.every(part => containsNumericRegex.test(part))) {
            return ""; // Return empty string if only numeric parts are present
        }
    
        // Join the remaining parts back into a comma-separated string
        return addressParts.join(', ');
    } catch (error) {
        return '';
    }
};
  
export const geoAddressTransformer = (response: any) => {
    const geoAddress = {
        house: '',
        area: '',
        city: '',
        state: '',
        pinCode: '',
        country: '',
    };

    const results = get(response, 'results');
    if (Array.isArray(results) && results.length) {
        const addressComponent = get(results[0], 'address_components');
        const formatted_address = get(results[0], 'formatted_address');
        /**
         * clean address function remove parts of formatted address that are not required in auto detect address
         * removes house no., pincode, state and country from address.
         */
        const cleanedAddress = cleanAddress(formatted_address);
        if (Array.isArray(addressComponent) && addressComponent.length) {
            if (cleanedAddress) {
                geoAddress.area = cleanedAddress;
            }
            addressComponent.forEach(value => {
                if (value.types.includes('neighborhood')) {
                    geoAddress.house = value['long_name'];
                }
                if (value.types.includes('locality')) {
                    geoAddress.city = value['long_name'];
                }
                if (value.types.includes('administrative_area_level_1')) {
                    geoAddress.state = value['long_name'];
                }
                if (value.types.includes('country')) {
                    geoAddress.country = value['short_name'];
                }
                if (value.types.includes('postal_code')) {
                    geoAddress.pinCode = value['long_name'];
                }
            });
            return geoAddress;
        }
    }

    return null;
};
